import { loadView } from '@/router'

export default [
  {
    path: 'accounts',
    name: 'manage-accounts',
    component: loadView('Application/Manage/Accounts'),
    redirect: {
      name: 'manage-accounts-list'
    },
    showInAlfred: true,
    alfredTitle: 'Manage - Accounts',
    children: [
      {
        path: 'list',
        name: 'manage-accounts-list',
        component: loadView('Application/Manage/Accounts/List')
      },
      {
        path: ':accountId',
        name: 'manage-accounts-account',
        component: loadView('Application/Manage/Accounts/Account'),
        redirect: {
          name: 'manage-accounts-account-details'
        },
        children: [
          {
            path: 'details',
            name: 'manage-accounts-account-details',
            component: loadView('Application/Manage/Accounts/Account/Details')
          },
          {
            path: 'configurations',
            name: 'manage-accounts-account-configurations',
            component: loadView('Application/Manage/Accounts/Account/Configuration'),
            redirect: {
              name: 'manage-accounts-account-configurations-edit'
            },
            children: [
              {
                path: 'edit',
                name: 'manage-accounts-account-configurations-edit',
                component: loadView('Application/Manage/Accounts/Account/Configuration/Edit')
              },
              {
                path: 'billing',
                name: 'manage-accounts-account-configurations-billing',
                component: loadView('Application/Manage/Accounts/Account/Configuration/Billing')
              },
              {
                path: 'shipper',
                name: 'manage-accounts-account-configurations-shipper',
                component: loadView('Application/Manage/Accounts/Account/Configuration/Shipper')
              },
              {
                path: 'notificationtemplates',
                name: 'manage-accounts-account-configurations-notificationtemplates',
                component: loadView('Application/Manage/Accounts/Account/Configuration/NotificationTemplates')
              },
              {
                path: 'trackingservices',
                name: 'manage-accounts-account-configurations-trackingservices',
                component: loadView('Application/Manage/Accounts/Account/Configuration/TrackingServices')
              },
              {
                path: 'carriers',
                name: 'manage-accounts-account-configurations-carriers',
                component: loadView('Application/Manage/Accounts/Account/Configuration/Carriers')
              },
              {
                path: 'rules',
                name: 'manage-accounts-account-configurations-rules',
                component: loadView('Application/Manage/Accounts/Account/Configuration/Rules')
              },
              {
                path: 'roles',
                name: 'manage-accounts-account-configurations-roles',
                component: loadView('Application/Manage/Accounts/Account/Configuration/Roles')
              },
              {
                path: 'webhooks',
                name: 'manage-accounts-account-configurations-webhook',
                component: loadView('Application/Manage/Accounts/Account/Configuration/Webhooks')
              },
              {
                path: 'teams',
                name: 'manage-accounts-account-configurations-teams',
                component: loadView('Application/Manage/Accounts/Account/Configuration/Teams'),
                redirect: {
                  name: 'manage-accounts-account-configurations-teams-index'
                },
                children: [
                  {
                    path: 'index',
                    name: 'manage-accounts-account-configurations-teams-index',
                    component: loadView('Application/Manage/Accounts/Account/Configuration/Teams/Teams')
                  },
                  {
                    path: ':teamId',
                    name: 'manage-accounts-account-configurations-teams-team',
                    component: loadView('Application/Manage/Accounts/Account/Configuration/Teams/Team'),
                    redirect: {
                      name: 'manage-accounts-account-configurations-teams-team-profiles'
                    },
                    children: [
                      {
                        path: 'profiles',
                        name: 'manage-accounts-account-configurations-teams-team-profiles',
                        component: loadView('Application/Manage/Accounts/Account/Configuration/Teams/Team/Profiles')
                      },
                      {
                        path: 'shippersettings',
                        name: 'manage-accounts-account-configurations-teams-team-shippersettings',
                        component: loadView('Application/Manage/Accounts/Account/Configuration/Teams/Team/ShipperSettings')
                      },
                      {
                        path: 'eventtemplates',
                        name: 'manage-accounts-account-configurations-teams-team-eventtemplates',
                        component: loadView('Application/Manage/Accounts/Account/Configuration/Teams/Team/EventTemplates')
                      },
                      {
                        path: 'blockedautobooks',
                        name: 'manage-accounts-account-configurations-teams-team-blockedautobooks',
                        component: loadView('Application/Manage/Accounts/Account/Configuration/Teams/Team/BlockedAutoBooks')
                      },
                      {
                        path: 'hideservices',
                        name: 'manage-accounts-account-configurations-teams-team-hideservices',
                        component: loadView('Application/Manage/Accounts/Account/Configuration/Teams/Team/HideServices')
                      },
                      {
                        path: 'clients',
                        name: 'manage-accounts-account-configurations-teams-team-clients',
                        component: loadView('Application/Manage/Accounts/Account/Configuration/Teams/Team/Clients')
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            path: 'billing',
            name: 'manage-accounts-account-billings',
            component: loadView('Application/Manage/Accounts/Account/Billing'),
            redirect: {
              name: 'manage-accounts-account-billings-invoicesurcharges'
            },
            children: [
              {
                path: 'invoicesurcharges',
                name: 'manage-accounts-account-billings-invoicesurcharges',
                component: loadView('Application/Manage/Accounts/Account/Billing/InvoiceSurcharges')
              }
            ]
          },
          {
            path: 'addresses',
            name: 'manage-accounts-account-addresses',
            component: loadView('Application/Manage/Accounts/Account/Addresses')
          },
          {
            path: 'cost-centres',
            name: 'manage-accounts-account-cost-centres',
            component: loadView('Application/Manage/Accounts/Account/CostCentres')
          },
          {
            path: 'attachments',
            name: 'manage-accounts-account-attachments',
            component: loadView('Application/Manage/Accounts/Account/Attachments')
          },
          {
            path: 'contacts',
            name: 'manage-accounts-account-contacts',
            component: loadView('Application/Manage/Accounts/Account/Contacts')
          },
          {
            path: 'locations',
            name: 'manage-accounts-account-locations',
            component: loadView('Application/Manage/Accounts/Account/Locations')
          },
          {
            path: 'notes',
            name: 'manage-accounts-account-notes',
            component: loadView('Application/Manage/Accounts/Account/Notes')
          },
          {
            path: 'dangerousgoods',
            name: 'manage-accounts-account-itemsdg',
            component: loadView('Application/Manage/Accounts/Account/DG')
          },
          {
            path: 'items',
            name: 'manage-accounts-account-items',
            component: loadView('Application/Manage/Accounts/Account/Items')
          },
          {
            path: 'surcharges',
            name: 'manage-accounts-account-surcharges',
            component: loadView('Application/Manage/Accounts/Account/Surcharges')
          },
          {
            path: 'ratecards',
            name: 'manage-accounts-account-ratecards',
            component: loadView('Application/Manage/Accounts/Account/RateCards')
          },
          {
            path: 'pickups',
            name: 'manage-accounts-account-pickups',
            component: loadView('Application/CustomerService/Accounts/Account/Pickups'),
            redirect: {
              name: 'manage-accounts-account-pickups-list'
            },
            children: [
              {
                path: 'list',
                name: 'manage-accounts-account-pickups-list',
                component: loadView('Application/CustomerService/Accounts/Account/Pickups/List')
              },
              {
                path: ':pickupId',
                name: 'manage-accounts-account-pickups-pickup',
                component: loadView('Application/CustomerService/Accounts/Account/Pickups/Pickup'),
                redirect: {
                  name: 'manage-accounts-account-pickups-pickup-details'
                },
                children: [
                  {
                    path: 'details',
                    name: 'manage-accounts-account-pickups-pickup-details',
                    component: loadView('Application/CustomerService/Accounts/Account/Pickups/Pickup/Details')
                  },
                  {
                    path: 'notes',
                    name: 'manage-accounts-account-pickups-pickup-notes',
                    component: loadView('Application/CustomerService/Accounts/Account/Pickups/Pickup/Notes')
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
]
